import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 volumes', '5 bónus', '240 páginas', '1.º ao 9.º ano'];
const reassurances = ['Download digital imediato', 'Ficheiros PDF para imprimir', 'Garantia de 7 dias'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15bsp5nr0okn9">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbk90547sv96" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ec7kzh1lxi50">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1n1833ii56g">
          As suas aulas de Educação Física podem estar <em className="text-red-700" data-id="element-118" data-mp="223d0fv3my8es">prontas já hoje.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="221jtsft0vo6s">
          Em vez de procurar jogos e fichas na internet, escrever cada aula do zero e passar os domingos à noite a planificar, tem um pack organizado de Educação Física para todo o ano letivo. Mais tempo para o que realmente importa:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x390dvx3m26f">
          Os seus alunos. As suas aulas. A sua vida fora da escola.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="120ip19cny9t7">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b2ru3jp5xaz7">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b1gqpkzmq58m">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1ktd2fyun1tvb">Pagamento único – sem subscrição.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1kv7c2h0glzk3">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1pthcb611jqck" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1ttrpb2n93h0x">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3qvqirsxrayku">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3lvudzrh8j348" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}